import React from 'react';
import { Link } from 'react-router-dom';
import './TermsOfService.css';

function TermsOfService() {
  return (
    <div className='terms-of-service'>
      <div style={{ padding: '2rem' }}>
        <h1>Terms of Service</h1>
        <p><strong>Effective Date:</strong> January 1st, 2025</p>
        <p><strong>Entity:</strong> Non-Target LLC ("PrivateIQ," "we," "us," "our")</p>
        <p><strong>Applies to:</strong></p>
        <ul>
          <li>non-target.com</li>
          <li>privateiq.golf</li>
          <li>PrivateIQ iOS companion app</li>
        </ul>
        <p><strong>Contact:</strong> <a href="mailto:support@privateIQ.golf">support@privateIQ.golf</a></p>

        <h2>1) Acceptance</h2>
        <p>
          By accessing the Sites or App (the "Services"), you agree to these Terms and our{' '}
          <Link to="/privacypolicy">Privacy Policy</Link>. If you do not agree, do not use the Services.
        </p>

        <h2>2) Eligibility</h2>
        <p>
          You must be at least 13 years old (or the minimum age required in your jurisdiction) to use the Services.
        </p>

        <h2>3) Accounts; Security</h2>
        <p>
          Accounts are created on privateiq.golf (not in-app). You are responsible for safeguarding your
          credentials and all activity under your account. Notify us promptly of unauthorized use.
        </p>

        <h2>4) Fees and Purchases</h2>
        <p>
          The App is free and offers no in-app purchases. Website purchases (if any) are billed by our
          payment processor under terms shown at checkout.
        </p>

        <h2>5) Companion App; No New Registration</h2>
        <p>
          The App is a companion for existing website users. New account registration is not offered in-app.
        </p>

        <h2>6) User Content & Conduct</h2>
        <p>
          You are responsible for content you post (e.g., forum posts, messages, uploads). You may not post
          illegal, infringing, harassing, hateful, defamatory, or confidential content, nor attempt to
          reverse engineer, scrape at scale, or disrupt the Services. We may remove content or suspend
          accounts at our discretion.
        </p>

        <h2>7) IQ Intro</h2>
        <p>
          We provide tools that let private clubs discover and contact prospective members.
        </p>
        <p>
          <strong>Pre-acceptance stage:</strong> Clubs may view limited non-direct identifiers about matched
          prospects (e.g., age range, income band, household composition band, proximity, and current-club
          status). No direct contact details are disclosed at this stage. You can opt out at any time
          (see <Link to="/privacypolicy">Privacy Policy</Link>).
        </p>
        <p>
          <strong>Acceptance stage:</strong> If you accept a club's request, you instruct us to disclose
          your selected attributes and contact details to that club. The club may export accepted leads
          to its CRM for prospective-member outreach for that club.
        </p>
        <p>
          <strong>Your control:</strong> You choose whether to accept, and you may later withdraw consent
          directly with the club; we can relay your request as a courtesy.
        </p>

        <h2>8) Clubs — Data License & No Re-Identification (Summary)</h2>
        <p>Clubs using IQ Intro agree to:</p>
        <ul>
          <li>(a) use data only to contact prospective members for that club;</li>
          <li>(b) not re-identify users from non-direct identifiers, and not combine with third-party data to unmask identity before acceptance;</li>
          <li>(c) not resell, transfer, or broker the data;</li>
          <li>(d) record the consent timestamp for accepted leads;</li>
          <li>(e) honor deletion/opt-out/suppression relayed by PrivateIQ within a commercially reasonable time; and</li>
          <li>(f) maintain reasonable security and allow PrivateIQ to verify compliance.</li>
        </ul>
        <p>Violation may result in suspension, termination, and available remedies.</p>

        <h2>9) Ownership; Feedback</h2>
        <p>
          We own the Services and related IP. You retain your rights in your content but grant us a
          worldwide, non-exclusive, royalty-free license to host, store, display, and distribute it
          to operate the Services. Feedback may be used without restriction.
        </p>

        <h2>10) Third-Party Services</h2>
        <p>
          Links or integrations (e.g., payment processors, analytics) are governed by the third party's
          terms and privacy policy.
        </p>

        <h2>11) Disclaimers</h2>
        <p>
          THE SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE." TO THE MAXIMUM EXTENT PERMITTED BY LAW,
          WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
        </p>

        <h2>12) Limitation of Liability</h2>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR INDIRECT, INCIDENTAL,
          SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS, DATA, OR
          GOODWILL. OUR AGGREGATE LIABILITY ARISING FROM THE SERVICES SHALL NOT EXCEED THE GREATER
          OF US$100 OR THE AMOUNT YOU PAID TO US IN THE 12 MONTHS BEFORE THE CLAIM.
        </p>

        <h2>13) Indemnity</h2>
        <p>
          You agree to indemnify and hold harmless Non-Target LLC from claims arising from your misuse
          of the Services or violation of these Terms.
        </p>

        <h2>14) Termination & Account Deletion</h2>
        <p>
          You may cancel at any time. You can initiate account deletion in the App at
          Settings &rarr; Account &rarr; Delete Account or by contacting support. We may suspend or
          terminate access for violations, risk, or legal reasons. Clauses that by nature survive
          (e.g., ownership, disclaimers, limitations, Sections 7–8) remain in effect.
        </p>

        <h2>15) Governing Law; Venue</h2>
        <p>
          These Terms are governed by the laws of the State of Texas and the United States, without
          regard to conflict-of-laws rules. Exclusive venue lies in state or federal courts in
          Travis County, Texas.
        </p>

        <h2>16) Changes</h2>
        <p>
          We may modify these Terms; updated Terms will be posted with a new Effective Date. Material
          changes may be communicated via in-app notice or email. Continued use after changes
          constitutes acceptance.
        </p>

        <h2>17) Contact</h2>
        <p>
          <a href="mailto:support@privateIQ.golf">support@privateIQ.golf</a>
        </p>
        <address>
          <strong>Non-Target LLC</strong><br />
          5511 Parkcrest Drive, Suite 103, #1000<br />
          Austin, TX 78731, USA
        </address>
      </div>
    </div>
  );
}

export default TermsOfService;